"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpAssessmentInstanceItem = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var react_bootstrap_1 = require("react-bootstrap");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var api_1 = require("../../../api");
var providers_1 = require("../../../providers");
var Icon_1 = require("../Icon/Icon");
var Constants_1 = require("../../Constants");
var DpItemAnalysisFactory_1 = __importDefault(require("../ItemAnalysis/ItemAnalysisFactory/DpItemAnalysisFactory"));
var DpStudentDetailsFactory_1 = __importDefault(require("../WWStudentsDetails/StudentDetailsFactory/DpStudentDetailsFactory"));
var DpStudentsSummary_1 = __importDefault(require("../StudentsSummary/DpStudentsSummary"));
var DpEmptyReportImage_1 = __importDefault(require("../DpEmptyReportImage/DpEmptyReportImage"));
var DpAssessmentInstanceItem_styled_1 = require("./DpAssessmentInstanceItem.styled");
var AtomicAlertManagerContext_1 = require("../AtomicAlert/AtomicAlertManagerContext");
var router_1 = require("next/router");
var WWDpStudentsDetailsQuestionAttemptModal_1 = require("../DpStudentsDetailsQuestionAttemptModal/WWDpStudentsDetailsQuestionAttemptModal");
var DpAssessmentInstanceItem = function (_a) {
    var assessment = _a.assessment, sections = _a.sections, isOpen = _a.isOpen, url = _a.url;
    // --------------------------------- Context
    var _b = (0, react_1.useContext)(api_1.ServiceContext), rubricRatingService = _b.rubricRatingService, userService = _b.userService, assigneePerformanceService = _b.assigneePerformanceService;
    var toast = (0, react_1.useContext)(AtomicAlertManagerContext_1.AtomicAlertManagerContext).toast;
    var router = (0, router_1.useRouter)();
    // --------------------------- State
    var _c = (0, react_1.useState)(isOpen), open = _c[0], setOpen = _c[1];
    var _d = (0, react_1.useState)(false), showData = _d[0], setShowData = _d[1];
    var _e = (0, react_1.useState)(false), initialized = _e[0], setInitialized = _e[1];
    var _f = (0, react_1.useState)(false), showAnalysisModal = _f[0], toggleShowAnalysisModal = _f[1];
    var _g = (0, react_1.useState)([]), studentsList = _g[0], setStudentsList = _g[1];
    var _h = (0, react_1.useState)([[]]), assigneesRubricPerformances = _h[0], setAssigneesRubricPerformances = _h[1];
    var _j = (0, react_1.useState)([]), assigneesPerformances = _j[0], setAssigneesPerformances = _j[1];
    var _k = (0, react_1.useState)([]), overallAssigneesRubricPerformances = _k[0], setOverallAssigneesRubricPerformances = _k[1];
    var _l = (0, react_1.useState)(undefined), overallPerformance = _l[0], setOverallPerformance = _l[1];
    var _m = (0, react_1.useState)([[]]), rubricCriterias = _m[0], setRubricCriterias = _m[1];
    var _o = (0, react_1.useState)({ itemExternalId: '', itemExternalBankItemId: '', questionNumber: 0 }), currentQuestionSelectedItem = _o[0], setCurrentQuestionSelectedItem = _o[1];
    var _p = (0, react_1.useState)([]), words = _p[0], setWords = _p[1];
    // --------------------------- Const
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var assessmentClass = assessment.assessmentClass, assessmentTemplate = assessment.assessmentTemplate, startDate = assessment.startDate, totalAssigned = assessment.totalAssigned, autoLaunch = assessment.autoLaunch;
    // --------------------------- Methods
    var getIconName = (0, react_1.useMemo)(function () { return (open ? 'chevron-up' : 'chevron-down'); }, [open]);
    var getTypes = (0, react_1.useMemo)(function () { return assessment.assessmentTemplate.items.map(function (item) { return item.scoringType; }); }, [assessment]);
    var getVariation = function (itemIndex) {
        return (0, api_1.getVariationsFrom)(assessment.assessmentTemplate.items[itemIndex].variation);
    };
    var toggle = function () { return setOpen(!open); };
    var goToStudentReport = function (studentId, valid, classId) {
        if (valid) {
            router.push("".concat(url, "/student/").concat(studentId, "?classId=").concat(classId));
        }
    };
    var toggleAnalysisModal = function (itemExternalId, itemExternalBankItemId, questionNumber, scoringType, modalOpen) {
        if (modalOpen === void 0) { modalOpen = false; }
        if (itemExternalId) {
            setCurrentQuestionSelectedItem({
                itemExternalId: itemExternalId,
                itemExternalBankItemId: itemExternalBankItemId,
                questionNumber: questionNumber,
                scoringType: scoringType,
            });
        }
        if (!modalOpen) {
            toggleShowAnalysisModal(function (prevState) { return !prevState; });
        }
    };
    var studentsForWWStudentsDetailsQuestionAttemptModal = (0, react_1.useMemo)(function () {
        if (currentQuestionSelectedItem.scoringType &&
            [api_1.ScoringType.Passage, api_1.ScoringType.Auto].includes(currentQuestionSelectedItem.scoringType)) {
            return assigneesPerformances.map(function (performance) { return performance.assignee; });
        }
        return studentsList;
    }, [currentQuestionSelectedItem.scoringType, assigneesPerformances, studentsList]);
    var fetchData = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var assigneesPerformanceData, overallAssigneePerformances, rubricRatingPerformances, itemCriterias, usersIds, students, rubricsAssigneesPerformances_1, overallRubricPerformance, assigneesPerformanceData, overallAssigneePerformances, wordsCount, itemWords, i, assigneesPerformanceData, overallAssigneePerformances, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 11, , 12]);
                    if (!assessment.assessmentTemplate.hasRubricItems) return [3 /*break*/, 6];
                    if (!assessment.assessmentTemplate.isNewRead) return [3 /*break*/, 2];
                    return [4 /*yield*/, assigneePerformanceService.getAssigneesPerformancesByClassAndTemplate([assessmentClass], assessmentTemplate, undefined, assessment)];
                case 1:
                    assigneesPerformanceData = _a.sent();
                    overallAssigneePerformances = assigneePerformanceService.getOverallAssigneesPerformanceByQuestion(assigneesPerformanceData, assessmentTemplate);
                    setAssigneesPerformances(assigneesPerformanceData);
                    setOverallPerformance(overallAssigneePerformances);
                    if (overallAssigneePerformances === null || overallAssigneePerformances === void 0 ? void 0 : overallAssigneePerformances.attempted) {
                        setShowData(true);
                    }
                    return [3 /*break*/, 5];
                case 2: return [4 /*yield*/, rubricRatingService.findByContextAndAssessment(sections, [assessment])];
                case 3:
                    rubricRatingPerformances = _a.sent();
                    if (!!(0, isEmpty_1.default)(rubricRatingPerformances)) return [3 /*break*/, 5];
                    itemCriterias = assessment.assessmentTemplate.items.map(function (item) {
                        var itemCriteria = new api_1.RubricCriteria({
                            externalId: item.externalId,
                            criteria: [],
                            type: item.scoringType,
                        });
                        var length = item.isRatingScoringType()
                            ? Object.keys((0, api_1.variationCriterias)((0, api_1.getVariationsFrom)(item.variation))).length
                            : item.maxScore;
                        for (var index = 1; index <= length; index++) {
                            itemCriteria.criteria.push(index);
                        }
                        return itemCriteria;
                    });
                    setRubricCriterias(itemCriterias.map(function (itemCriteria) {
                        return itemCriteria.criteria.map(function (criteria) { return criteria.toString(); });
                    }));
                    usersIds = rubricRatingPerformances.map(function (performance) { return performance.userId; });
                    return [4 /*yield*/, userService.findByIds(usersIds, true, true)];
                case 4:
                    students = _a.sent();
                    setStudentsList(students);
                    rubricsAssigneesPerformances_1 = rubricRatingService.getAssigneesRubricRatingsByClassAndAssessment(students, itemCriterias, rubricRatingPerformances);
                    overallRubricPerformance = itemCriterias.map(function (itemCriteria, i) {
                        return rubricRatingService.getItemOverallAssigneeRubricPerformances(itemCriteria.criteria, rubricsAssigneesPerformances_1[i]);
                    });
                    setAssigneesRubricPerformances(rubricsAssigneesPerformances_1);
                    setOverallAssigneesRubricPerformances(overallRubricPerformance);
                    if (rubricsAssigneesPerformances_1 === null || rubricsAssigneesPerformances_1 === void 0 ? void 0 : rubricsAssigneesPerformances_1.length) {
                        setShowData(true);
                    }
                    _a.label = 5;
                case 5: return [3 /*break*/, 10];
                case 6:
                    if (!assessment.assessmentTemplate.isVocabularyAssignment) return [3 /*break*/, 8];
                    return [4 /*yield*/, assigneePerformanceService.getAssigneesPerformancesVocabularyByClassAndTemplate([assessmentClass], assessment, undefined)];
                case 7:
                    assigneesPerformanceData = _a.sent();
                    overallAssigneePerformances = assigneePerformanceService.getOverallAssigneesPerformanceByWord(assigneesPerformanceData, assessmentTemplate);
                    wordsCount = assessmentTemplate.items[0].maxScore;
                    itemWords = [];
                    for (i = 0; i < wordsCount; i++) {
                        itemWords.push((i + 1).toString());
                    }
                    setWords(itemWords);
                    setAssigneesPerformances(assigneesPerformanceData);
                    setOverallPerformance(overallAssigneePerformances);
                    if (overallAssigneePerformances === null || overallAssigneePerformances === void 0 ? void 0 : overallAssigneePerformances.attempted) {
                        setShowData(true);
                    }
                    return [3 /*break*/, 10];
                case 8: return [4 /*yield*/, assigneePerformanceService.getAssigneesPerformancesByClassAndTemplate([assessmentClass], assessmentTemplate, undefined, assessment)];
                case 9:
                    assigneesPerformanceData = _a.sent();
                    overallAssigneePerformances = assigneePerformanceService.getOverallAssigneesPerformanceByQuestion(assigneesPerformanceData, assessmentTemplate);
                    setAssigneesPerformances(assigneesPerformanceData);
                    setOverallPerformance(overallAssigneePerformances);
                    if (overallAssigneePerformances === null || overallAssigneePerformances === void 0 ? void 0 : overallAssigneePerformances.attempted) {
                        setShowData(true);
                    }
                    _a.label = 10;
                case 10: return [3 /*break*/, 12];
                case 11:
                    error_1 = _a.sent();
                    toast({
                        alertVariant: 'error',
                        content: {
                            title: t('errorMessages.oopsErr'),
                            message: t('errorMessages.assessmentLoad'),
                        },
                    });
                    return [3 /*break*/, 12];
                case 12:
                    setInitialized(true);
                    return [2 /*return*/];
            }
        });
    }); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        assessment,
        rubricRatingService,
        sections,
        assessmentClass,
        assessmentTemplate,
        assigneePerformanceService,
        userService,
    ]);
    var handleOpen = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            toggle();
            return [2 /*return*/];
        });
    }); };
    var getStudentsText = (0, react_1.useMemo)(function () {
        return totalAssigned === assessmentClass.totalStudents
            ? t('assessmentInstanceItem.allStudents')
            : "".concat(totalAssigned, "/").concat(assessmentClass.totalStudents, " ").concat(t('assessmentInstanceItem.students'));
    }, [assessmentClass, t, totalAssigned]);
    (0, react_1.useEffect)(function () {
        if (open) {
            fetchData();
        }
    }, [open, fetchData]);
    // --------------------------- Render
    var getStudentsSection = function (index) {
        return index === 0 ? ((0, jsx_runtime_1.jsx)("div", { className: "students", children: (0, jsx_runtime_1.jsx)(DpStudentsSummary_1.default, { assessment: assessment, classes: sections }) })) : null;
    };
    var getTitle = function (index) {
        return assessment.assessmentTemplate.hasRubricItems &&
            assessment.assessmentTemplate.items.length > 1 &&
            (assessment.assessmentTemplate.items[index].isRatingScoringType() ||
                assessment.assessmentTemplate.items[index].isMatrixScoringType()) && ((0, jsx_runtime_1.jsxs)("h3", { className: "item-title", children: [t('assessmentInstanceItem.item'), " ", index + 1] }));
    };
    return ((0, jsx_runtime_1.jsx)(react_bootstrap_1.ListGroup.Item, { as: "li", id: assessment.id, "data-testid": "DpAssessmentInstanceItem", children: (0, jsx_runtime_1.jsxs)(DpAssessmentInstanceItem_styled_1.StyledAssessmentInstanceItem, { children: [(0, jsx_runtime_1.jsx)("div", { className: "collapse-header d-flex justify-content-between ".concat(open ? 'open' : ''), children: (0, jsx_runtime_1.jsxs)("div", { className: "header-content", children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { className: "date", children: (0, jsx_runtime_1.jsx)("span", { className: "date-wrap", children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("span", { className: "short-format", children: [(0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: "calendar" }), providers_1.dateProvider.formatByString(startDate, Constants_1.SHORT_FORMAT)] }), autoLaunch && ((0, jsx_runtime_1.jsx)("span", { className: "time", children: providers_1.dateProvider.formatByString(startDate, Constants_1.TIME_FORMAT) }))] }) }) }), (0, jsx_runtime_1.jsxs)("div", { className: "assessment-title", children: [(0, jsx_runtime_1.jsxs)("div", { className: "title text-truncate", children: [assessmentTemplate.title, " "] }), (0, jsx_runtime_1.jsx)("div", { className: "section text-truncate", children: assessmentClass.displayName })] }), (0, jsx_runtime_1.jsx)("div", { className: "students", children: (0, jsx_runtime_1.jsx)("span", { className: "student-wrap", children: getStudentsText }) })] }), (0, jsx_runtime_1.jsx)("button", { onClick: handleOpen, "aria-controls": "collapse-content-".concat(assessment.id), "aria-expanded": open, className: "open-assessment icon-btn", "aria-label": t('assessmentInstanceItem.assessmentReport'), children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: getIconName }) })] }) }), (0, jsx_runtime_1.jsx)(react_bootstrap_1.Collapse, { in: open, children: (0, jsx_runtime_1.jsx)("div", { id: "collapse-content-".concat(assessment.id), children: initialized &&
                            (rubricCriterias === null || rubricCriterias === void 0 ? void 0 : rubricCriterias.map(function (criterias, i) {
                                return showData ? ((0, jsx_runtime_1.jsxs)("div", { className: "item-".concat(i + 1), children: [getTitle(i), (0, jsx_runtime_1.jsxs)("div", { className: "overview-section ww", children: [getStudentsSection(i), (0, jsx_runtime_1.jsx)("div", { className: "item-analysis", children: (0, jsx_runtime_1.jsx)(DpItemAnalysisFactory_1.default, { identifier: i, scoringType: getTypes[i], assessment: assessment, overallRubricPerformance: overallAssigneesRubricPerformances[i], overallPerformance: overallPerformance, openItemAnalysisModal: toggleAnalysisModal }) })] }), (0, jsx_runtime_1.jsx)(DpStudentDetailsFactory_1.default, { assessment: assessment, classes: sections, assigneeRubricPerformance: assigneesRubricPerformances[i], overallRubricPerformance: overallAssigneesRubricPerformances[i], assigneePerformance: assigneesPerformances, overallPerformance: overallPerformance, criterias: criterias.length > 0 ? criterias : words, scoringType: getTypes[i], variation: getVariation(i), goToStudentReportHandler: goToStudentReport })] }, "item-".concat(i))) : ((0, jsx_runtime_1.jsx)(DpEmptyReportImage_1.default
                                // @ts-ignore
                                , {}, i));
                            })) }) }), open && ((0, jsx_runtime_1.jsx)(WWDpStudentsDetailsQuestionAttemptModal_1.WWDpStudentsDetailsQuestionAttemptModal, { assessment: assessment, showStudentAttemptQuestionModal: showAnalysisModal, currentQuestionSelectedItem: currentQuestionSelectedItem, studentsList: studentsForWWStudentsDetailsQuestionAttemptModal, toggleAnalysisModal: toggleAnalysisModal }))] }) }));
};
exports.DpAssessmentInstanceItem = DpAssessmentInstanceItem;
exports.default = exports.DpAssessmentInstanceItem;
